import { Menu, UnstyledButton, Group, Text, rem } from '@mantine/core';
import { IconChevronDown, IconLogout, IconUserStar } from '@tabler/icons-react';
import { useAuth } from '../auth';

export const UserDropdown = () => {
  const { user, signOut } = useAuth();

  if (!user) return null;

  return (
    <Menu shadow="md" width={200} position="bottom-end">
      <Menu.Target>
        <UnstyledButton
          style={{
            padding: '8px 12px',
            borderRadius: '6px',
            color: 'white',
            transition: 'background-color 0.2s ease',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#1c7ed6';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <Group gap="xs" wrap="nowrap">
            <IconUserStar size={22} color="white" />
            <Text
              size="sm"
              fw={500}
              visibleFrom="sm"
              style={{
                color: 'white',
                lineHeight: 1,
              }}
            >
              {user.email?.split('@')[0] || 'User'}
            </Text>
            <IconChevronDown
              size={12}
              color="white"
              style={{ display: 'var(--mantine-visible-from-sm)' }}
            />
          </Group>
        </UnstyledButton>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconLogout style={{ width: rem(14), height: rem(14) }} />}
          onClick={signOut}
        >
          Sign Out
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
